<template>
  <div class="row justify-content-left align-items-left">
    <div class="col-md-12">
      <!-- Header bar -->
      <div style="background-color:#3460A8;color:white;padding:20px;margin-bottom:20px;margin-top:-10px;">
        {{
          currentStrategy?.keyword
          || $t('crosswalk.strategySetup.headerFallback')
        }}
      </div>

      <!-- Strategy Keyword (short name) -->
      <div class="col-md-12 px-3">
        <div v-if="currentStrategy">
          <MDBInput
              :label="$t('crosswalk.strategySetup.strategyKeywordLabel')"
              :disabled="!editMode"
              v-model="currentStrategy.keyword"
              @blur="strategyDetailsStore.exitedField()"
              @change="strategyDetailsStore.allStrategyDetailsChanged()"
          />
        </div>
      </div>

      <br />

      <!-- Full Strategy -->
      <div class="col-md-12 px-3">
        <div v-if="currentStrategy">
          <MDBTextarea
              :label="$t('crosswalk.strategySetup.fullStrategyLabel')"
              :disabled="!editMode"
              rows="2"
              v-model="currentStrategy.name"
              @blur="strategyDetailsStore.exitedField()"
              @change="strategyDetailsStore.allStrategyDetailsChanged()"
          />
        </div>
      </div>

      <br />

      <!-- Sub-strategies -->
      <div v-if="currentStrategy">
        <div
            v-for="(subStrategy, subStrategyIndex) in currentStrategy.subStrategies"
            :key="subStrategyIndex"
            class="row offset-1 col-md-12"
        >
          <br /><br />

          <div class="col-md-9">
            <MDBTextarea
                rows="2"
                :label="$t('crosswalk.strategySetup.subStrategyLabel')"
                :disabled="!editMode"
                v-model="subStrategy.name"
                @blur="strategyDetailsStore.exitedField()"
                @change="strategyDetailsStore.allStrategyDetailsChanged()"
            />
            <br />
          </div>

          <div class="col-md-9">
            <div v-if="subStrategy">
              <MDBInput
                  :label="$t('crosswalk.strategySetup.subStrategyKeywordLabel')"
                  :disabled="!editMode"
                  v-model="subStrategy.keyword"
                  @blur="strategyDetailsStore.exitedField()"
                  @change="strategyDetailsStore.allStrategyDetailsChanged()"
              />
            </div>
            <br /><br />
          </div>

          <div v-if="editMode" class="col-md-1" style="text-align:left;">
            <MDBTooltip v-model="removesubtooltip[setupStrategyId][subStrategyIndex]">
              <template #reference>
                <MDBBtn
                    color="primary"
                    floating
                    @click="removeSubStrategy(setupStrategyId, subStrategyIndex)"
                >
                  <FontAwesomeIcon icon="fa-solid fa-minus" />
                </MDBBtn>
              </template>
              <template #tip>{{ $t('crosswalk.strategySetup.tooltips.removeSubStrategy') }}</template>
            </MDBTooltip>
            <br /><br />
          </div>
        </div>
      </div>

      <!-- Add Sub-strategy -->
      <div v-if="editMode" class="offset-1" style="margin-bottom:20px;text-align:left;">
        <MDBTooltip v-model="addsubtooltip[setupStrategyId]">
          <template #reference>
            <MDBBtn color="primary" floating @click="addSubStrategy(setupStrategyId)">
              <FontAwesomeIcon icon="fa-solid fa-plus" />
            </MDBBtn>
          </template>
          <template #tip>{{ $t('crosswalk.strategySetup.tooltips.addSubStrategy') }}</template>
        </MDBTooltip>
      </div>

      <!-- Order -->
      <div class="offset-md-4 col-md-4 px-3">
        <div v-if="currentStrategy">
          <label class="form-label">{{ $t('crosswalk.strategySetup.orderLabel') }}</label>
          <select
              class="form-select"
              :disabled="!editMode"
              v-model.number="currentStrategy.order"
              @change="onOrderChanged"
          >
            <option
                v-for="n in strategyDetailsStore.allStrategyDetails.length"
                :key="n"
                :value="n"
            >
              {{ n }}
            </option>
          </select>
        </div>
      </div>

      <br />

      <!-- Remove Strategy -->
      <div>
        <a
            v-if="editMode"
            @click="clickRemoveStrategy"
            class="btn btn-outline-danger"
        >
          {{ $t('crosswalk.strategySetup.removeStrategy') }}
        </a>
      </div>

      <br />
    </div>
  </div>
</template>

<script src="./_SingleStrategySetup.js" lang="js"></script>
<style src="./_SingleStrategySetup.less" lang="less" scoped></style>
